import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const addWish = (customerId, allocationId, wish) => {
  const newWish = wish;
  return axios.post(
    `${getV2RootUrl()}/customer/${customerId}/allocation/${allocationId}/wish`,
    newWish,
    axiosHeaderV2()
  );
};
